// extracted by mini-css-extract-plugin
module.exports = {"decorator":"_2DiicKpW-HLFvF8wpDIsKU","icon":"_3g3pOIjvm_iT18EGn4nNqX"};